import { render, staticRenderFns } from "./educationForm.vue?vue&type=template&id=a0a77710&"
import script from "./educationForm.vue?vue&type=script&lang=js&"
export * from "./educationForm.vue?vue&type=script&lang=js&"
import style0 from "./educationForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports